module.exports = __webpack_public_path__ + "static/media/mongoDBLogo.e6cebe06.png";